var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "M17 42q-1.25 0-2.125-.875T14 39V17q0-1.25.875-2.125T17 14h22q1.25 0 2.125.875T42 17v22q0 1.25-.875 2.125T39 42Zm0-19.7h22V17H17Zm8.3 8.4h5.4v-5.4h-5.4Zm0 8.3h5.4v-5.3h-5.4ZM17 30.7h5.3v-5.4H17Zm16.7 0H39v-5.4h-5.3ZM17 39h5.3v-5.3H17V39Zm16.7 0H39v-5.3h-5.3ZM9 34q-1.25 0-2.125-.875T6 31V9q0-1.25.875-2.125T9 6h22q1.25 0 2.125.875T34 9v3.5h-3V9H9v22h3.5v3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/manual.0d57a8155c76acc5d8429b06db6801d7.svg";
export { ForwardRef as ReactComponent };